import { Component } from '@angular/core';

@Component({
  selector: 'app-student-counselling-report-link',
  templateUrl: './student-counselling-report-link.component.html',
  styleUrls: ['./student-counselling-report-link.component.scss']
})
export class StudentCounsellingReportLinkComponent {

}
